const STORAGE_KEY = 'pixiePageScroll';
const CLASS_NAME = 'pixie-page-scroll';

function readStoredFlag() {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function writeStoredFlag(enabled) {
  try {
    if (enabled) {
      localStorage.setItem(STORAGE_KEY, '1');
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Ignore quota / private-mode failures.
  }
}

/** Parse ?scroll=1 / ?scroll=0. Returns null when the query is absent. */
export function queryScrollFlag(search) {
  const raw =
    search ?? (typeof window !== 'undefined' ? window.location.search : '');
  const value = new URLSearchParams(raw).get('scroll');
  if (value === '1' || value === 'true') return true;
  if (value === '0' || value === 'false') return false;
  return null;
}

export function isPageScrollEnabled() {
  if (typeof document === 'undefined') return false;
  return document.documentElement.classList.contains(CLASS_NAME);
}

export function setPageScrollEnabled(enabled) {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle(CLASS_NAME, !!enabled);
  writeStoredFlag(!!enabled);
}

/**
 * Query wins over localStorage so Grok Bot can force on/off per URL.
 * Default (no query, no stored flag) stays locked for existing users.
 */
export function applyPageScrollFromLocation(search) {
  const fromQuery = queryScrollFlag(search);
  const enabled = fromQuery === null ? readStoredFlag() : fromQuery;
  setPageScrollEnabled(enabled);
  return enabled;
}
